import { SkillForm } from "@/core/skillForms/types";
import { createInitialPetitionSkillStep2 } from "../step2";

export const createCivilInitialPetitionSkillForm: SkillForm = {
  skillId: "create_civil_initial_petition",
  title: "Petição Inicial Cível",
  steps: [createInitialPetitionSkillStep2],
  lastStepSubmitButtonText: "Criar Petição Inicial",
};
